const INTERNAL_DOMAINS = ['transgourmet.ch'];

export function isInternalUrl(url: string): boolean {
  if (!url || (!url.includes('://') && !url.startsWith('//'))) {
    return true;
  }

  try {
    const absoluteUrl = url.startsWith('//') ? `https:${url}` : url;
    const hostname = new URL(absoluteUrl).hostname;
    return INTERNAL_DOMAINS.some(domain => hostname === domain || hostname.endsWith('.' + domain));
  } catch {
    return true;
  }
}

export function getLinkRel(url: string): string | undefined {
  return isInternalUrl(url) ? undefined : 'noopener noreferrer';
}

export function sortSearchParams(searchParams: URLSearchParams) {
  const sortedParams = new URLSearchParams();
  const sortedKeys = Array.from(searchParams.keys()).sort((a, b) => a.localeCompare(b));

  sortedKeys.forEach(key => {
    const values = searchParams.getAll(key);
    values.forEach(value => {
      sortedParams.append(key, value);
    });
  });

  return sortedParams;
}